module.exports = __webpack_public_path__ + "static/img/55-2.c084c26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/55-2.jpg
// module id = 8KkD
// module chunks = 0